import { useMatchMedia } from "../../UI/Hooks/useMatchMedia";
import { ResponsiveBreakpoints } from "../../UI/ResponsiveBreakpoints";
import { Column, Row } from "../../UI/LayoutComponents/LayoutComponents";

export type TwoColumnLayoutItem = {
  condition?: boolean;
  content: JSX.Element;
};

type TwoColumnLayoutList = TwoColumnLayoutItem[];

const LayoutComponent = ({ content }: { content: JSX.Element }) => <div>{content}</div>;

const useTwoColumnLayout = (componentList: TwoColumnLayoutList, mobileLeftFirst?: boolean) => {
  const isDesktop = useMatchMedia(ResponsiveBreakpoints.Desktop);

  const visibleComponents = componentList.filter(({ condition = true }) => condition);

  const [leftColumn, rightColumn] = [visibleComponents.filter((_, i) => i % 2 === 0), visibleComponents.filter((_, i) => i % 2 === 1)];

  if (isDesktop === undefined) {
    return null;
  }

  if (isDesktop) {
    return (
      <Row>
        {leftColumn.length > 0 && (
          <Column>
            {leftColumn.map(({ content }, i) => (
              <LayoutComponent key={i} content={content} />
            ))}
          </Column>
        )}
        {rightColumn.length > 0 && (
          <Column>
            {rightColumn.map(({ content }, i) => (
              <LayoutComponent key={i} content={content} />
            ))}
          </Column>
        )}
      </Row>
    );
  } else {
    const componentsData = mobileLeftFirst ? [...leftColumn, ...rightColumn] : visibleComponents;

    return (
      <Row>
        {visibleComponents.length > 0 && (
          <Column>
            {componentsData.map(({ content }, i) => (
              <LayoutComponent key={i} content={content} />
            ))}
          </Column>
        )}
      </Row>
    );
  }
};

export { useTwoColumnLayout };
